import { BaseComponent } from "utils/base-component"

import { Nearby } from "../nearby"
import { LocationSearchApi } from "./api"
import { SearchItem } from "./data"
import { List } from "./list"
import "./index.scss"

export { SearchItem } from "./data"

let id = 0

export class LocationSearch extends BaseComponent {
  static cssClass = "location-search"
  static offsetY = 2

  private input!: HTMLInputElement
  private list!: List
  private api!: LocationSearchApi
  private nearest?: Nearby
  private scheduled: NodeJS.Timeout

  init() {
    const labelId = `textbox-${id}`
    id += 1

    this.api = new LocationSearchApi()

    this.list = new List(null, { labelId, onChoose: (l) => this.choose(l) })

    const input = this.element("input")!.element as HTMLInputElement
    input.id = labelId
    input.setAttribute("role", "combobox")
    input.setAttribute("aria-expanded", "false")
    input.setAttribute("aria-haspopup", "listbox")
    input.setAttribute("aria-autocomplete", "list")
    input.setAttribute("aria-controls", this.list.root.id)
    input.addEventListener("input", () => this.queryChanged())
    input.addEventListener("keydown", (e) => this.onKeyDown(e))
    input.addEventListener("focus", () => this.show())
    input.addEventListener("blur", () => this.blurred())
    this.input = input

    this.nearest = Nearby.for({})
  }

  private choose(item: SearchItem) {
    item.open(() => {
      const placeholder = this.input.getAttribute("placeholder")
      this.input.value = ""
      this.input.disabled = true
      this.input.setAttribute("placeholder", "Please wait…")
      this.hide()
      setTimeout(() => {
        this.input.disabled = false
        this.input.setAttribute("placeholder", placeholder)
      }, 100)
    })
  }

  private queryChanged() {
    if (this.scheduled) clearTimeout(this.scheduled)
    this.scheduled = setTimeout(() => this.loadSuggestions(), 200)
  }

  private async loadSuggestions() {
    const query = this.input.value
    const result = await this.api.get(query)
    if (query !== this.input.value) return

    this.list.setState(query, result)
    if (result.length) this.setExpanded(true)
  }

  private onKeyDown(event: KeyboardEvent) {
    if (["Enter"].includes(event.key)) {
      event.preventDefault()
      this.choose(this.list.selectedItem())
    }

    if (["Escape", "Esc"].includes(event.key)) {
      event.preventDefault()
      this.input.blur()
    }

    if (["ArrowUp", "Up"].includes(event.key)) {
      event.preventDefault()
      this.list.selectUp()
    }

    if (["ArrowDown", "Down"].includes(event.key)) {
      event.preventDefault()
      this.list.selectDown()
    }
  }

  private setExpanded(expanded: boolean, showNearest?: boolean) {
    if (expanded) {
      this.appendChild(this.list)

      if (showNearest) {
        this.list.appendChild(this.nearest)
      } else {
        this.nearest.remove()
      }
    } else {
      this.list.remove()
    }
  }

  show() {
    this.setExpanded(true, true)
    this.loadSuggestions()
  }

  blurred() {
    // if we're blurring because of a click, let item's click handler to be executed
    setTimeout(() => this.hide(), 250)
  }

  hide() {
    this.list.setState("", [])
    this.setExpanded(false)
  }
}
